module.exports = "<div class=\"wrapper-back\">\n    <div>\n        <clr-icon shape=\"warning\" class=\"is-warning\" size=\"96\"></clr-icon>\n        <span class=\"status-code\">404</span>\n        <span class=\"status-text\">{{'PAGE_NOT_FOUND.MAIN_TITLE' | translate}}</span>\n    </div>\n    <div class=\"status-subtitle\">\n        {{'PAGE_NOT_FOUND.SUB_TITLE' | translate}} <span class=\"second-number\">{{leftSeconds}}</span> {{'PAGE_NOT_FOUND.UNIT' | translate}}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/not-found/not-found.component.html
// module id = 892
// module chunks = 0